import React from 'react';
import { formatwebsiteUrls } from 'helpers/FormatKeywordsHelper';
import InternalLinksList from 'components/shared/TextDisplay/InternalLinksList';
import InternalLinksBox from 'components/shared/TextDisplay/InternalLinksBox';
import './InternalLinkingSection.css';
import { useTranslation } from 'react-i18next';

const InternalLinkingSection = ({
  data,
  details,
  isEditing,
  websites, // List of internal links provided
  actualHtmlContent,
  setIsEditing,
  handleInputChange,
  checkIfAllLinesGreen, // Function to verify if all links are properly formatted
  userRole,
}) => {
  console.log('isEditing', isEditing);

  const sectionData = data;
  const { t } = useTranslation();
  return (
    <div className="internal-linking-section">
      {/* Links List */}
      <div onClick={() => setIsEditing(true)}>
        {' '}
        <InternalLinksBox
          isEditing={isEditing}
          websites={websites}
          actualHtmlContent={actualHtmlContent}
          setIsEditing={setIsEditing}
          handleInputChange={handleInputChange}
          checkIfAllLinesGreen={checkIfAllLinesGreen}
          userRole={userRole}
          t={t}
        />
      </div>

      {/* Recommendation */}

      <div className="subsection-content">
        {data.recommendation && (
          <div className="ux-recommendation">
            <span className="recommendation-icon"></span>
            <div className="recommendation-content">
              <span className="recommendation-label">
                {t('Notre recommandation')} :{' '}
              </span>
              <span className="recommendation-text">
                {t(data.recommendation)}
              </span>
            </div>
          </div>
        )}

        {data.gratification && (
          <div className="success-message">
            <span className="emoji">🎉</span> {t(data.gratification)}
          </div>
        )}
      </div>
    </div>
  );
};

export default InternalLinkingSection;
